import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ReverLogo } from '../../icons';
import { useTheme } from '../../theme';
import usePoweredByRevertStyles from './PoweredByRerver.Styles';
export const PoweredByRever = () => {
    const theme = useTheme();
    const styles = usePoweredByRevertStyles({ theme });
    return (_jsxs("a", { className: styles.a, href: "https://itsrever.com/", target: "_blank", rel: "noreferrer", children: [_jsx(ReverLogo, { className: styles.icon, color: theme.colors.grey[2] }), _jsx("span", { className: styles.text, children: "Powered by REVER" })] }));
};
export default PoweredByRever;
